import KnowledgeBaseEventManager from "./KnowledgeBaseEventManager";

export default KnowledgeBaseEventManager;
